"use client";

import { useEffect } from "react";
import { useMerchant } from "@/app/providers/merchantProvider";
import { useMerchantFeatureFlag } from "@/utils/useMerchantFeatureFlag";
import { FEATURE_FLAG_QUANTUM_METRIC } from "@/utils/constants";

const SCRIPT_TAG_ID = "js-quantum-metric-clover";

export function QuantumMetrics() {
  const { merchant } = useMerchant();
  const isQuantumMetricEnabled = useMerchantFeatureFlag(
    merchant,
    FEATURE_FLAG_QUANTUM_METRIC
  );

  useEffect(() => {
    if (!isQuantumMetricEnabled) return;

    if (document.head.querySelector(`script#${SCRIPT_TAG_ID}`)) return;

    const script = document.createElement("script");

    script.src =
      process.env.NEXT_PUBLIC_QUANTUM_METRIC_SCRIPT_URL ||
      "https://cdn.quantummetric.com/qscripts/quantum-clover-test.js";

    script.type = "text/javascript";
    script.async = true;
    script.id = SCRIPT_TAG_ID;

    document.head.appendChild(script);
  }, [isQuantumMetricEnabled]);

  return null;
}
